import React from 'react';
import { SvgIcon, SvgIconProps } from "@mui/material";

export const ContextAddIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path opacity=".5" fill-rule="evenodd" clip-rule="evenodd" d="M3 1h18v2L3 3.01V1Zm18 5.01L3 6v2h18V6.01ZM3 11h8v2H3v-2Z" /><path fill-rule="evenodd" clip-rule="evenodd" d="M18.07 10.36c.09.1.14.22.14.35v5.15h5.15a.5.5 0 0 1 .5.5v1.42a.5.5 0 0 1-.5.5H18.2v5.15a.5.5 0 0 1-.5.5h-1.4a.5.5 0 0 1-.5-.5v-5.15h-5.15a.5.5 0 0 1-.5-.5v-1.42a.5.5 0 0 1 .5-.5h5.15V10.7a.5.5 0 0 1 .5-.5h1.42a.5.5 0 0 1 .36.15Z" />
    </SvgIcon>
);
